import {Injectable, InjectionToken} from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import {DialogService} from "primeng/dynamicdialog";

@Injectable({
    providedIn: 'root',
})
export class HrPersonnelPickerReplaySubjectService {
    private onShowSource$: ReplaySubject<boolean> = new ReplaySubject(1);
    onShow$: Observable<boolean> = this.onShowSource$.asObservable();

    constructor() {}

    public startOnShowProcess() {
        this.onShowSource$.next(true);
    }
}
export const CUSTOM_DIALOG_SERVICE = new InjectionToken<DialogService>('CustomDialogService');
